import _ from "lodash";
import { useEffect, useState } from "react";
import { api } from "../utils";
import { toast } from "react-toastify";
import axios from "axios";
const cancelToken = axios.CancelToken;
const source = cancelToken.source();

export default function useGetPrinters(props) {
  const [printers, setPrinters] = useState({
    PrinterList: [],
    PrinterSuccess: false,
  });

  function formatPrinters(data) {
    let printerArr = _.concat(data.labels, data.lasers, data.parts);
    let list = _.map(printerArr, (x) => {
      return { label: x.nameOnly, value: x.id };
    });
     return list.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0));
  }

  useEffect(() => {
      api
      .fetchS("Printer/GetPrintersForDropdown", {}, source.token)
      .then((response) => {
        if (response) {
            setPrinters({
                PrinterList: formatPrinters(response.data),
                PrinterSuccess: true
            });
          } else {
            toast.error("Failed to get printers.");
          }
      })
      .catch(api.catchHandler);
  }, []);

  return printers;
}
